import { mapGetters } from 'vuex';
import mvtShifter from '@/common/components/mvtshifter/mvt-shifter.vue';
import mvtListLinks from '@/common/components/mvtlistlinks/mvt-listlinks.vue';
import schoolsCity from '../schoolscity/schools-city.vue';
import schoolsDistrict from '../schoolsdistrict/schools-district.vue';
import schoolsWelcome from '../schoolswelcome/schools-welcome.vue';
import schoolsNeighbourhood from '../schoolsneighbourhood/schools-neighbourhood.vue';
import schoolsDistrictState from '../schoolsdistrictstate/schools-districtstate.vue';
import schoolsZipcode from '../schoolszipcode/schools-zipcode.vue';
import schoolsBase from '../schoolsbase/schools-base.vue';
import schoolsState from '../schoolsstate/schools-state.vue';
import staticWelcomeSearch from '../staticwelcomesearch/static-welcome-search.vue';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';

export default {
    name: 'pageSchools',
    inject: ['$eventBus'],
    components: {
        mvtShifter,
        mvtHeader,
        mvtDialogCenter,
        mvtListLinks,
        schoolsCity,
        schoolsDistrict,
        schoolsNeighbourhood,
        schoolsZipcode,
        schoolsBase,
        schoolsState,
        schoolsDistrictState,
        schoolsWelcome,
        staticWelcomeSearch,
        mvtFooter,
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb']),
        ...mapGetters('schools', ['geo']),
        schoolsData() {
            return this.glb.pageData;
        },
        schoolSrc() {
            return this.glb.cdnUrl + 'images/desktop/schools_static.png';
        },
        pageInfo() {
            return this.glb.pageData.cityInfo || this.glb.pageData.neighInfo || this.glb.pageData.stateInfo || {};
        },
        urlsInfo() {
            let pageType = this.schoolsData.pageType;
            let appUrl = this.glb.appUrl;
            let urlsInfo = {};
            if (pageType === 'vschools_districtstate') {
                urlsInfo.listings = { show: true, url: `${appUrl}${this.pageInfo.sitemapStatePageUrl}` };
                urlsInfo.markettrends = { show: true, url: `${appUrl}${this.pageInfo.sitemapStatePageUrl}market-trends/` };
                urlsInfo.schools = { show: true, url: `${appUrl}schools/` };
            } else if (pageType === 'vschools_neighbourhood') {
                urlsInfo.listings = { show: false, url: `` };
                urlsInfo.markettrends = { show: true, url: `${appUrl}${this.pageInfo.neighborhoodStatisticsPageUrl}` };
                urlsInfo.schools = { show: true, url: `${appUrl}schools/` };
            } else if (pageType === 'vschools_zipcode') {
                urlsInfo.listings = { show: true, url: `${appUrl}${this.pageInfo.nameForUrl}/${this.schoolsData.zipcode}` };
                urlsInfo.markettrends = { show: true, url: `${appUrl}${this.pageInfo.nameForUrl}/${this.schoolsData.zipcode}/market-trends/` };
                urlsInfo.schools = { show: true, url: `${appUrl}schools/` };
            } else if (pageType === 'vschools_city' || pageType === 'vschools_district') {
                urlsInfo.listings = { show: true, url: `${appUrl}${this.pageInfo.sitemapCityPropertyPageUrl}` };
                urlsInfo.markettrends = { show: true, url: `${appUrl}${this.pageInfo.cityStatisticsPageUrl}` };
                urlsInfo.schools = { show: true, url: `${appUrl}schools/` };
            }
            return urlsInfo;
        },
    },
    mounted() {
        this.$eventBus.$emit('eventbus-pageLoaded');
    },
};
